import React from 'react';
import moment from 'moment-timezone';
import { DateTimeDisplay } from './date-time-display';
import { WIDGET_LOCALE } from '../../locale-wrapper';

export const EventTime = ({ event, settings, className = '' }) => {
  const dateTBD = event.get('date_tbd');
  if (dateTBD) return <span />;
  const startTime = event.getIn(['date', 'start', 'utc']);
  const endTime = event.getIn(['date', 'end', 'utc']);
  const allDay = event.get('all_day_event');
  const timeZone = settings.get('automaticTimezone') ? moment.tz.guess() : event.getIn(['date', 'start', 'timezone']);

  let momentStartTime = moment(startTime);
  let momentEndTime = moment(endTime);
  if (startTime && timeZone) {
    momentStartTime = moment(startTime).tz(timeZone);
    momentEndTime = moment(endTime).tz(timeZone);
  } else {
    momentStartTime = moment(startTime).utc();
    momentEndTime = moment(endTime).utc();
  }

  const locale = event.get('type') === 'eventviewer' ? WIDGET_LOCALE : event.get('locale', 'en').split('_')[0];

  const momentStartLocale = momentStartTime.locale(locale);
  const momentEndLocale = momentEndTime.locale(locale);

  const timezone = settings.get('includeTimezone') ? ' z' : '';

  return (
    <DateTimeDisplay
      settings={settings}
      showStart={allDay ? false : settings.get('showTime', false)}
      showEnd={allDay ? false : settings.get('showEndTime', false)}
      momentStartLocale={momentStartLocale}
      momentEndLocale={momentEndLocale}
      format={`${settings.get('timeFormat')} ${timezone}`}
      className={className}
    />
  );
};
